<template>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer mr-5" :style="'color:' + colorDrop" >
    <span class="cursor-pointer flex items-center i18n-locale" >
<!--      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />-->
        <div  v-if="activetabsVn == 'activetabs'"><img class="h-4 w-6 mr-2"
                                                       src="../../../../assets/images/flags/vn.png" alt="de"/></div>
        <div   v-if="activetabsEn == 'activetabs'"><img class="h-4 w-6 mr-2"
                                                        src="../../../../assets/images/flags/en.png" alt="en"/></div>
        <!--      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>-->
    </span>
        <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown" >
            <vs-dropdown-item @click="updateLocale('vn')" :class="activetabsVn"><img class="h-4 w-5 mr-1"
                                                                                     src="../../../../assets/images/flags/vn.png" alt="de"/>
                &nbsp;Vietnamese
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('en')" :class="activetabsEn"><img class="h-4 w-5 mr-1"
                                                                                     src="../../../../assets/images/flags/en.png" alt="en"/>
                &nbsp;English
            </vs-dropdown-item>
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
import VeeValidate, { Validator } from "vee-validate";

export default {
    name: "LanguageInface",
    data() {
        return {
            conset: 'vi-VN',
            activetabsVn: 'activetabs',
            activetabsEn: ''
        }
    },
    computed: {
        i18n_locale_img() {
            const locale = this.$i18n.locale
            if (locale === 'en') return require('../../../../assets/images/flags/en.png')
            else if (locale === 'vn') return require('../../../../assets/images/flags/vn.png')
            else return require('../../../../assets/images/flags/vn.png')
        },
        getCurrentLocaleData() {
            const locale = this.$i18n.locale
            if (locale === 'en') return {flag: 'us', lang: 'English'}
            else if (locale === 'vn') return {flag: 'vn', lang: 'Vietnamese'}
            else if (locale === 'vi') return {flag: 'vn', lang: 'Vietnamese'}
        },
    },
    props: {
        colorDrop: ''
    },
    methods: {
        updateLocale(locale) {
            location.reload();
            this.$i18n.locale = locale
            this.$eventBus.$emit("i18n", locale);
            if (locale === 'en') locale = 'en-US';
            if (locale === 'vn') locale = 'vi-VN';
            localStorage.setItem("language", locale)
        }
    },
    mounted() {
        this.conset = localStorage.getItem('language');
        if (this.conset == 'en-US') {
            this.activetabsVn = '';
            this.activetabsEn = 'activetabs'
        }
        if (this.conset == 'vi-VN') {
            this.activetabsVn = 'activetabs';
            this.activetabsEn = ''
        }
    }
}
</script>

<style scoped>
feather-icon {
    color: white !important;
}
</style>
<style lang="scss">
.activetabs {
    background: rgb(5 152 98 / 1);
    color: white;
}
</style>
